import React, { Fragment } from 'react';
import { connect, Provider } from 'react-redux';

import { withStyles, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';
import { Grid, Button } from '@material-ui/core';

import { AppState, store, Actions, PanelState, IPageState } from '../../appredux'
import ReactDOM from 'react-dom';
import themeDialog from '../../themes-dialog';
import SmsCode, { Data } from '../dialog/SmsCode';
import { fontSelect } from '../../fonts';
import CONFIG from '../../cfg/config';

import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';

//PM 2021-10-15
//poprawka typow
type PlatnoscProps = {
  page: IPageState,
}

class Platnosc extends React.Component<PlatnoscProps & WithStyles<typeof styles>, any> {
  textTheme = fontSelect(this.props.page.fonts, 10, 2) as React.CSSProperties;

  //PM 2021-10-15
  //poprawka typow
  openSms = async () => {
    let data = new Data()

    await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
    ReactDOM.render(
      <Provider store={store}>
        <MuiThemeProvider theme={themeDialog}>
          <SmsCode data={data} />
        </MuiThemeProvider>
      </Provider>
      , document.getElementById("dialog_sms"));
    await store.dispatch(Actions.pageState.openDialogSms());
  }

  //PM 2021-10-15
  //dodanie ikonek platnosci
  render() {
    const classes = this.props.classes;

    //console.log(this.props.page.contact)

    return (
      <Grid item xs={12} md={12} >
         <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            <PaidOutlinedIcon className={classes.icon}/>
          </Typography>
        {this.props.page.contact.payWeb === "0" ?
          (
            <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
              Płatność przy odbiorze zamówienia.
            </Typography>
          )
          : this.props.page.contact.payWeb === "2" ?
            (
              <Fragment>
                <Typography variant="h6" component="h2" color="primary" style={this.textTheme} gutterBottom>
                  Płatność przez internet.
                </Typography>
                <a href={`https://vsc24.net/vscZasady/zasady/CashBill/${CONFIG.hotelID}`} rel="noreferrer" target="_blank">
                  <img alt="Płatności CashBill" src="https://img.cashbill.pl/cb/logo/00-logotypy/c-cashbill_100x39_b.png" width="100" height="39" />
                </a>
              </Fragment>
            )
            : this.props.page.contact.payWeb === "3" ?
              (
                <Fragment>
                  <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
                    Płatność przy odbiorze zamówienia.
                  </Typography>
                  {/* <Typography variant="h6" component="h2" color="primary">
              <p></p>
            </Typography> */}
                  <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
                    Wymagane jest potwierdzenie zamówienia przez sms kod.
                  </Typography>
                  <Typography variant="h6" component="h2" color="primary">
                    <p></p>
                  </Typography>
                  <Button onClick={this.openSms} variant="contained" size="small" color="primary"
                    style={{ textTransform: "none", fontSize: "0.8rem" }}
                  >
                    <b>sms kod</b>
                  </Button>
                </Fragment>
              )
              : this.props.page.contact.payWeb === "4" ?
                (
                  <Fragment>
                    <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
                      {"Możliwe dwie płatności:"}
                    </Typography>
                    <Typography variant="h6" component="h2" color="primary">
                      <p></p>
                    </Typography>
                    <Typography variant="h6" component="h2" color="primary" style={this.textTheme} gutterBottom>
                      {"1. Płatność w internecie."}
                    </Typography>
                    <a href={`https://vsc24.net/vscZasady/zasady/CashBill/${CONFIG.hotelID}`} rel="noreferrer" target="_blank">
                      <img alt="Płatności CashBill" src="https://img.cashbill.pl/cb/logo/00-logotypy/c-cashbill_100x39_b.png" width="100" height="39" />
                    </a>
                    <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
                      {"2. Płatność przy odbiorze. Wymagane potwierdzenie zamówienie przez sms kod."}
                    </Typography>
                    <Typography variant="h6" component="h2" color="primary">
                      <p></p>
                    </Typography>
                    <Button onClick={this.openSms} variant="contained" size="small" color="primary"
                      style={{ textTransform: "none", fontSize: "0.8rem" }}
                    >
                      <b>sms kod</b>
                    </Button>
                  </Fragment>
                )
                : this.props.page.contact.payWeb === "1" ?
                  (
                    <Fragment>
                      <Typography variant="h6" component="h2" color="primary" style={this.textTheme} gutterBottom>
                        Płatność przez internet.
                      </Typography>
                      <a href="https://vsc24.net/vscZasady/zasady/Przelewy24/Standard" target="_blank" rel="noreferrer">
                        <img src="img/Przelewy24_logo.png" style={{ maxWidth: '70px' }} alt="Płatności Przelewy24" />
                      </a>
                    </Fragment>
                  )
                  : this.props.page.contact.payWeb === "5" ?
                    (
                      <Fragment>
                        <Typography variant="h6" component="h2" color="primary" style={this.textTheme} gutterBottom>
                          Płatność przez internet.
                        </Typography>
                        <a
                          href={`https://vsc24.net/vscZasady/zasady/TPay/${CONFIG.hotelID}`}
                          target="_blank"
                          rel="noreferrer"
                          title="Obsługujemy płatności internetowe przez system płatności online Tpay"
                        >
                          <img src="https://tpay.com/img/banners/tpay_zaufane_platnosci.svg" style={{ border: 0, maxWidth: '110px' }} alt="Logo Tpay" title="Logo Tpay" />
                        </a>
                      </Fragment>
                    )
                    : null
        }
      </Grid>
    );

  }
}

const styles = (theme: Theme) => ({
  icon:{
    width: "30px !important",
    height: "30px !important",
    paddingBottom: "5px"
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(Platnosc));